import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Priya Sharma",
      role: "MS in Computer Science, USA",
      image: "👩‍🎓",
      rating: 5,
      text: "RIC made my dream of studying at Stanford a reality. Their guidance on university selection, SOP writing, and visa process was exceptional. Highly recommended!",
      country: "🇺🇸 USA"
    },
    {
      name: "Rajesh Kumar",
      role: "Software Engineer, Canada",
      image: "👨‍💻",
      rating: 5,
      text: "The team helped me secure a PR in Canada within 8 months. Their expertise in documentation and process management is unmatched. Thank you for changing my life!",
      country: "🇨🇦 Canada"
    },
    {
      name: "Ananya Reddy",
      role: "MBA Graduate, UK",
      image: "👩‍💼",
      rating: 5,
      text: "From scholarship application to visa approval, RIC handled everything professionally. I got into London Business School with a 50% scholarship!",
      country: "🇬🇧 UK"
    },
    {
      name: "Vikram Patel",
      role: "Nurse, Australia",
      image: "👨‍⚕️",
      rating: 5,
      text: "The work visa process seemed complex, but RIC simplified everything. Now I'm working in Melbourne with my family. Forever grateful!",
      country: "🇦🇺 Australia"
    }
  ];

  return (
    <section id="testimonials" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-green-100 text-green-700 rounded-full px-4 py-2 mb-4">
            <Star className="w-4 h-4 fill-current" />
            <span className="text-sm font-semibold">Success Stories</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-900">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of successful students and professionals who achieved their international dreams with us
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="group relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:border-indigo-300 hover:shadow-2xl transition-all duration-300">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-indigo-200 group-hover:text-indigo-300 transition" />
              
              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 mb-6 leading-relaxed relative z-10">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center text-3xl shadow-lg">
                  {testimonial.image}
                </div>
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-sm font-medium text-indigo-700 mt-1">{testimonial.country}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Video Testimonials CTA */}
        <div className="bg-gradient-to-r from-indigo-700 to-purple-700 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Watch More Success Stories</h3>
          <p className="text-indigo-100 mb-6 max-w-2xl mx-auto">
            Hear directly from our clients about their journey and how we helped them achieve their goals
          </p>
          <button className="bg-white text-indigo-700 px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition transform hover:scale-105">
            View Video Testimonials
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
